"use client";

import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface AppleSignInButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  className?: string;
}

export function AppleSignInButton({
  onClick,
  isLoading = false,
  className = "",
}: AppleSignInButtonProps) {
  return (
    <Button
      variant="outline"
      className={`w-full ${className}`}
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M17.05 12.04c-.02-2.05 1.68-3.04 1.75-3.09-.95-1.4-2.44-1.59-2.97-1.61-1.26-.13-2.47.74-3.11.74-.65 0-1.63-.72-2.69-.7-1.38.02-2.66.8-3.37 2.04-1.44 2.5-.37 6.19 1.03 8.22.68.99 1.49 2.1 2.56 2.06 1.03-.04 1.42-.66 2.66-.66 1.24 0 1.59.66 2.68.64 1.11-.02 1.81-1 2.49-2 .78-1.15 1.1-2.26 1.12-2.32-.02-.01-2.15-.82-2.17-3.26zM15.1 6.21c.57-.69.95-1.65.85-2.61-.82.03-1.81.55-2.4 1.23-.53.61-.99 1.58-.86 2.51.91.07 1.84-.46 2.41-1.13z"
        />
      </svg>
      Continue with Apple
    </Button>
  );
}
